/**
 * Public shop delivery + free-shipping flags (from GET /orders/get-shipping-cost?businessId=).
 * Use this for cart, checkout, and policies so messaging stays in sync with the dashboard.
 */
const FALLBACK_FREE = 100;

const defaultInfo = () => ({
  freeThreshold: FALLBACK_FREE,
  showFreeShippingPromo: true,
  useDefaultFreeShippingThreshold: true,
  shippingCost: 10,
  currency: 'AUD',
  customerPickupEnabled: false,
});

/**
 * @param {{ apiBaseV1: string, businessId?: string }} p
 */
export async function fetchShopDeliveryInfo({ apiBaseV1, businessId }) {
  const base = (apiBaseV1 || '').replace(/\/$/, '');
  const q = (businessId || '').trim();
  const url = q
    ? `${base}/orders/get-shipping-cost?businessId=${encodeURIComponent(q)}`
    : `${base}/orders/get-shipping-cost`;
  try {
    const res = await fetch(url);
    if (!res.ok) return defaultInfo();
    const d = await res.json();
    const freeThreshold = Number(d.freeThreshold);
    return {
      freeThreshold: Number.isFinite(freeThreshold) && freeThreshold >= 0 ? freeThreshold : FALLBACK_FREE,
      showFreeShippingPromo: d.showFreeShippingPromo !== false,
      useDefaultFreeShippingThreshold: d.useDefaultFreeShippingThreshold !== false,
      shippingCost: d.shippingCost != null ? Number(d.shippingCost) : 10,
      currency: typeof d.currency === 'string' ? d.currency : 'AUD',
      customerPickupEnabled: d.customerPickupEnabled === true,
    };
  } catch {
    return defaultInfo();
  }
}

export const SHOP_DEFAULT_FREE_THRESHOLD_AUD = 100;
export const SHOP_CUSTOM_FREE_SHIP_MAX_AUD = 10_000;
